import { Component, Input, OnInit } from '@angular/core';
import { AtualizacoesProaAudit } from '../models/atualizacoes-proa-audit';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { AtualizacoesProaAuditService } from '../services/atualizacoes-proa-audit.service';

@Component({
  selector: 'app-historico-atualizacoes-proa-list',
  templateUrl: './historico-atualizacoes-proa-list.component.html',
  styleUrls: ['./historico-atualizacoes-proa-list.component.scss']
})
export class HistoricoAtualizacoesProaListComponent extends BaseListComponent<AtualizacoesProaAudit> implements OnInit {
  @Input() audit: AtualizacoesProaAudit; // contém o campo da fk da tabela a ser auditada
  atualizacoes: AtualizacoesProaAudit[] = [];
  visivel: boolean = false;
  show: boolean = false;

  constructor(
    private myService: AtualizacoesProaAuditService,
  ) {
    super();
  }

  ngOnInit() {
    if (typeof this.audit != 'undefined') {
      this.show = true;
      this.initLoadDataTable();
    } else {
      this.loaded();
    }
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.getAtualizacoes(this.audit).subscribe((res) => {
        this.atualizacoes = res;
        this.atualizacoes.forEach(audit => {
          audit.summary = '<li>' + audit.summary.replace(/[\r\n]+/g, "</li><li>") + '</li>';
          audit.summary = audit.summary.replace("\n", "</li><li>");
        });

        this.loaded();
      })
    );
  }
}
